import type { Profile } from '../../../services/auth';
import { logToNewRelic } from '../../../services/debug';
import { getServerFlag, getUserStats, ldClient } from '../../../services/launchDarkly';
import type { RiveFTUEConfig } from '../../../services/types';
import type { CleanGeoData, RawGeoData } from '../../geography/types';

export const ONBOARDING_STEP_STORAGE_KEY = (firebaseUid: string) => `onboarding_current_step:${firebaseUid}`;

export function reportEvenUserFtue({
  profile,
  riveConfig,
  loadedFileUrl,
  viewType,
  rawGeo,
  cleanGeo,
}: {
  profile: Profile | null | undefined;
  riveConfig: RiveFTUEConfig;
  loadedFileUrl?: string;
  viewType?: 'desktop' | 'mobile';
  rawGeo: RawGeoData | null;
  cleanGeo: CleanGeoData | null;
}) {
  const userStats = getUserStats(profile?.stats);
  const userIdString = userStats?.user_id_string;
  const baseContext = {
    firebaseUid: profile?.firebaseUid,
    user_id: profile?.userId,
    user_id_string: userIdString,
  };

  if (typeof userIdString !== 'string') {
    logToNewRelic('FTUE even user', 'FTUE started for even user_id', 'info', baseContext);
    return;
  }
  if (!/[02468]$/.test(userIdString)) {
    return;
  }

  const fileName = (url?: string) => url?.split('/').pop();
  const loadedFile = fileName(loadedFileUrl);
  const serverFlagConfig = getServerFlag<RiveFTUEConfig>('rive_ftue_config');
  const serverFlagFileConfig =
    viewType === 'desktop' ? serverFlagConfig?.desktop : serverFlagConfig?.mobile_web || serverFlagConfig?.mobile_m;
  const serverFlagFile = fileName(serverFlagFileConfig?.url);

  logToNewRelic('FTUE even user', 'FTUE started for even user_id', 'info', {
    ...baseContext,
    loaded_file: loadedFile,
    server_flag_file: serverFlagFile,
    sdk_server_file_mismatch: loadedFile !== serverFlagFile,
    ld_context_key_matches_user: ldClient?.getContext()?.key === profile?.firebaseUid,
    ftue_type: riveConfig?.ftue_type,
    view_type: viewType,
    geo_country: rawGeo?.countryCode,
    geo_region: rawGeo?.region,
    geo_is_vpn: rawGeo?.isVPN,
    geo_territory_key: cleanGeo?.territoryKey,
    user_territory_key: profile?.territory?.key,
    user_country_code: profile?.territory?.countryCode,
  });
}
